import { earnedAchievementsFromGrants } from "@dailywars/core/achievements";
import { getAchievementProfileSummary } from "@dailywars/core/db";
import { entitlementsFromPlayer } from "@dailywars/core/entitlements";
import { createServerFn } from "@tanstack/react-start";

import { getRequestLogger } from "#/lib/requestLogger.server";
import { emptyServerInputSchema } from "#/lib/serverInputSchemas";
import { authedMiddleware } from "#/server/authedMiddleware";
import { buildProfileActivityForPlayer } from "#/server/game/profileActivity.server";
import { shapeOwnPlayerProfile } from "#/server/playerProfileShape";

export const loadProfilePage = createServerFn({ method: "GET" })
  .middleware([authedMiddleware])
  .validator(emptyServerInputSchema)
  .handler(async ({ context }) => {
    const { userId, player } = context;
    const entitlements = entitlementsFromPlayer(player);
    const [activity, achievementSummary, profile] = await Promise.all([
      buildProfileActivityForPlayer(userId),
      getAchievementProfileSummary({ playerId: userId, latestLimit: 5 }),
      shapeOwnPlayerProfile(player),
    ]);

    getRequestLogger().set({
      user: { id: userId, tier: entitlements.tier },
      route: { action: "profile_page" },
    });

    return {
      profile,
      activity,
      achievements: earnedAchievementsFromGrants(achievementSummary.latestGrants),
      earnedAchievementCount: achievementSummary.earnedCount,
      entitlements,
    };
  });
